'use client';
import styles from "./AiSummaryBar.module.scss";

// "✨ Özetle" trigger that reveals each AI assistant (with its real icon) on
// hover / focus (click). Pure CSS reveal — server component, no client JS.
const ENGINES = [
  { key: "chatgpt", name: "ChatGPT", icon: "/blog/ai/chatgpt.svg", src: "prompt", build: (q) => `https://chatgpt.com/?prompt=${q}` },
  { key: "google", name: "Google AI", icon: "/blog/ai/google.svg", src: "query", build: (q) => `https://www.google.com/search?udm=50&aep=11&q=${q}` },
  { key: "grok", name: "Grok", icon: "/blog/ai/grok.svg", src: "prompt", build: (q) => `https://x.com/i/grok?text=${q}` },
  { key: "perplexity", name: "Perplexity", icon: "/blog/ai/perplexity.svg", src: "prompt", build: (q) => `https://www.perplexity.ai/search/new?q=${q}` },
  { key: "claude", name: "Claude", icon: "/blog/ai/claude.svg", src: "prompt", build: (q) => `https://claude.ai/new?q=${q}` },
];

export default function AiSummaryBar({ title, url, locale = "en", label }) {
  if (!title) return null;

  const query = encodeURIComponent(title);
  const promptText =
    locale === "tr"
      ? `"${title}" başlıklı şu makaleyi benim için özetle: ${url}`
      : `Summarize this article titled "${title}" for me: ${url}`;
  const prompt = encodeURIComponent(promptText);

  return (
    <details className={styles.wrap} onKeyDown={event => { if (event.key === "Escape") { event.currentTarget.open = false; event.currentTarget.querySelector("summary")?.focus(); } }}>
      <summary className={styles.trigger}>
        <span className={styles.spark} aria-hidden="true">
          ✨
        </span>
        {label}
      </summary>

      <div className={styles.menu}>
        {ENGINES.map((engine) => (
          <a
            key={engine.key}
            className={styles.item}
            href={engine.build(engine.src === "query" ? query : prompt)}
            target="_blank"
            rel="noopener noreferrer nofollow"
            title={engine.name}
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img className={styles.icon} src={engine.icon} alt="" width={18} height={18} />
            <span>{engine.name}</span>
          </a>
        ))}
      </div>
    </details>
  );
}

